export const messages = {
  en: {
    resourceOutManage: {
      orderId: 'Order ID',
      itemType: 'Item Type',
      itemName: 'Item Name',
      itemSpec: 'Item Specification',
      itemCode: 'Item Code',
      itemStock: 'Stock',
      applyQuantity: 'Apply Quantity',
      issueQuantity: 'Issue Quantity',
      issueQuantityPlaceholder: 'Required, please enter issue quantity',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      submit: 'Submit',
      quantityRequired: 'Please enter issue quantity',
      insufficientStock: 'Insufficient stock',
      submitSuccess: 'Submit success',
      submitError: 'Submit failed',
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    resourceOutManage: {
      orderId: '单号',
      itemType: '物品类型',
      itemName: '物品名称',
      itemSpec: '物品规格',
      itemCode: '物品编码',
      itemStock: '物品库存',
      applyQuantity: '申请数量',
      issueQuantity: '发放数量',
      issueQuantityPlaceholder: '必填，请填写发放数量',
      remark: '备注',
      remarkPlaceholder: '可填，请填写备注',
      submit: '提交',
      quantityRequired: '请填写发放数量',
      insufficientStock: '库存不足',
      submitSuccess: '提交成功',
      submitError: '提交失败',
      fetchError: '获取数据失败'
    }
  }
}